export default "__VITE_ASSET__ByMNeJxO__"